import makeStyles from '@mui/styles/makeStyles';
import { Theme } from '@mui/material/styles';

export const useAccordionStyles = makeStyles(
  (theme: Theme) => {
    return {
      accordion: {
        width: '100%',
        backgroundColor: 'transparent',
        color: 'inherit',
        boxShadow: 'none',

        '& .v5-MuiAccordionSummary-root': {
          minHeight: 0,
          padding: 0,
          marginBottom: '8px',
        },
        '& .v5-MuiAccordionSummary-content': {
          margin: 0,

          '& .v5-MuiTypography-body1': {
            fontSize: '1.125rem',
            fontWeight: 500,
          },
        },
      },
      accordionSummary: {
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
      },
      accordionHeader: {
        display: 'flex',
        alignItems: 'center',
        '& .v5-MuiAccordionSummary-expandIconWrapper': {
          order: '-1',
          alignSelf: 'center',
          marginRight: '.5rem',
        },
      },
      accordionDetails: {
        padding: '1rem 0',
      },
      cardCtaButton: {
        minWidth: '8.75rem',
        whiteSpace: 'nowrap',
        padding: '.5rem 1.5rem',
        borderRadius: '10rem',
        textTransform: 'none',
        border: `1px solid ${theme.palette?.mode === 'light' ? '#00A868' : '#2EFFAF'}`,
        color: theme.palette?.mode === 'light' ? '#00A868' : '#FFFFFF',
        fontSize: '.875rem',
        '&:hover': {
          backgroundColor: 'transparent',
          border: `1px solid ${theme.palette?.mode === 'light' ? '#00A868' : '#2EFFAF'}`,
        },
      },
    };
  },
  { name: 'Accordion' },
);
